import React from 'react';
import { SwiperOptions } from 'swiper';
import { IProps, IChildElement } from 'components/SliderNews/types';
import Slider from 'components/Slider';

const SliderNews: React.FC<IProps> & IChildElement = (props) => {
  const config: SwiperOptions = {
    slidesPerView: 1,
    loop: props.loopSetting,
    autoplay: {
      disableOnInteraction: false
    }
  };

  return (
    <div className="slider-news">
      <Slider
        name={props.name}
        config={config}
        pagination={false}
      >
        {props.children}
      </Slider>
    </div>
  );
};

SliderNews.Item = Slider.Item;

export default SliderNews;
